import { render, staticRenderFns } from "./supplierIndex.vue?vue&type=template&id=16932724"
import script from "./supplierIndex.vue?vue&type=script&lang=js"
export * from "./supplierIndex.vue?vue&type=script&lang=js"
import style0 from "./supplierIndex.vue?vue&type=style&index=0&id=16932724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports